import { useTranslation } from "@refinedev/core";
import DateTimePicker from "components/datetimePicker";
import Input from "components/input";
import { Label } from "components/label";
import { IAdditionalSetupForm, ISimpleEventDetail } from "interfaces";
import { get } from "lodash";
import moment from "moment";
import { Controller, useFormContext } from "react-hook-form";

export const LegalInfo = ({
  isEdit,
}: {
  isEdit: boolean;
  eventDetailData: ISimpleEventDetail;
}) => {
  const { translate } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<IAdditionalSetupForm>(); // retrieve all hook methods
  console.log(errors);
  return isEdit ? (
    <div className="box-container p-4 sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.company_name" name="Tên công ty" />
          <Input
            id="legal_info.company_name"
            placeholder="Tên công ty"
            error={errors["legal_info"]?.company_name}
            {...register("legal_info.company_name")}
          />
          {errors["legal_info"]?.company_name ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.company_name?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.address" name="Địa chỉ" />
          <Input
            id="legal_info.address"
            placeholder="Địa chỉ"
            error={errors["legal_info"]?.address}
            {...register("legal_info.address")}
          />
          {errors["legal_info"]?.address ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.address?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.tax_code" name="Mã số thuế" />
          <Input
            id="legal_info.tax_code"
            placeholder="Mã số thuế"
            error={errors["legal_info"]?.tax_code}
            {...register("legal_info.tax_code")}
          />
          {errors["legal_info"]?.tax_code ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.tax_code?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.phone" name="Điện thoại" />
          <Input
            id="legal_info.phone"
            placeholder="Điện thoại"
            error={errors["legal_info"]?.phone}
            {...register("legal_info.phone")}
          />
          {errors["legal_info"]?.phone ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.phone?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.representative" name="Đại diện" />
          <Input
            id="legal_info.representative"
            placeholder="Đại diện"
            error={errors["legal_info"]?.representative}
            {...register("legal_info.representative")}
          />
          {errors["legal_info"]?.representative ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.representative?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.position" name="Chức vụ" />
          <Input
            id="legal_info.position"
            placeholder="Chức vụ"
            error={errors["legal_info"]?.position}
            {...register("legal_info.position")}
          />
          {errors["legal_info"]?.position ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.position?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.account_name" name="Tên tài khoản ngân hàng" />
          <Input
            id="legal_info.account_name"
            placeholder="Tên tài khoản ngân hàng"
            error={errors["legal_info"]?.account_name}
            {...register("legal_info.account_name")}
          />
          {errors["legal_info"]?.account_name ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.account_name?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.account_number" name="Số tài khoản" />
          <Input
            id="legal_info.account_number"
            placeholder="Số tài khoản"
            error={errors["legal_info"]?.account_number}
            {...register("legal_info.account_number")}
          />
          {errors["legal_info"]?.account_number ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.account_number?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.bank" name="Ngân hàng" />
          <Input
            id="legal_info.bank"
            placeholder="Ngân hàng"
            error={errors["legal_info"]?.bank}
            {...register("legal_info.bank")}
          />
          {errors["legal_info"]?.bank ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.bank?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.contract_number" name="Số hợp đồng" />
          <Input
            id="legal_info.contract_number"
            placeholder="Số hợp đồng"
            error={errors["legal_info"]?.contract_number}
            {...register("legal_info.contract_number")}
          />
          {errors["legal_info"]?.contract_number ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.contract_number?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.service_fee" name="Phí dịch vụ (%)" />
          <Input
            id="legal_info.service_fee"
            placeholder="Phí dịch vụ"
            type="number"
            step="0.01"
            error={errors["legal_info"]?.service_fee}
            {...register("legal_info.service_fee", {
              setValueAs: (v) => (v === "" ? null : parseFloat(v)),
            })}
          />
          {errors["legal_info"]?.service_fee ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.service_fee?.message}
              </span>
            </p>
          ) : null}
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.vat" name="Thuế GTGT (%)" />
          <Input
            id="legal_info.vat"
            placeholder="Thuế GTGT"
            type="number"
            step="0.01"
            error={errors["legal_info"]?.vat}
            {...register("legal_info.vat", {
              setValueAs: v => v === '' ? null : parseFloat(v) 
            })}
          />
          {errors["legal_info"]?.vat ? (
            <p className="error-text">
              <span className="font-medium">
                {errors["legal_info"]?.vat?.message}
              </span>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
